import { createFileRoute } from '@tanstack/react-router';
import { DataOwnerDetail } from '@/features/data-owners/DataOwnerDetail';

export const Route = createFileRoute('/_shell/data-owners/$dataOwnerId')({
  component: DataOwnerDetailRoute,
});

function DataOwnerDetailRoute() {
  const { dataOwnerId } = Route.useParams();
  return <DataOwnerDetail dataOwnerId={dataOwnerId} />;
}
